import { GET_LEVELS_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const levelsCore  = handleActions(
  { 
    [ GET_LEVELS_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return action.payload.data
      }
    }
  }, []
)